/* eslint-disable prettier/prettier */
/* eslint-disable */

/* DashboardStatsContainer.tsx */

import React, { useState } from 'react';

import styles from './DashboardStatsContainer.module.css';

// import DashboardStatCard from '';

/* ICONS */
import learnerIcon from '../../../../assets/coach/img1.png';
import attendanceIcon from '../../../../assets/coach/img2.png';
import sessionIcon from '../../../../assets/coach/img3.png';
import assignmentIcon from '../../../../assets/coach/img4.png';
import DashboardStatCard from './DashboardStatCard';
import LearnersAssignedModal from './LearnersAssignedModal';
import { useCoachActionCenter } from '../../../../hooks/useCoachActionCenter';
import { useCoachProfilePrograms } from '../../../../hooks/useCourse';

const DashboardStatsContainer: React.FC = () => {
	/* MODAL STATE */
	const [openLearnerModal, setOpenLearnerModal] = useState(false);
	const [openAttendanceModal, setOpenAttendanceModal] = useState(false);
	const [openAssignmentModal, setOpenAssignmentModal] = useState(false);

	/* DROPDOWN STATE */
	const [selectedProgram, setSelectedProgram] = useState('');

	const { learnerOverviewData, learnerOverviewLoading } =
		useCoachActionCenter(selectedProgram, 1, 50);

	const userDataString = localStorage.getItem('user');

	let coachId = '';

	if (userDataString) {
		try {
			const userData = JSON.parse(userDataString);

			coachId = userData.id;
		} catch {
			coachId = '';
		}
	}
	const { programs } = useCoachProfilePrograms(coachId);

	const handleCloseLearnerModal = () => {
		setSelectedProgram('');
		setOpenLearnerModal(false);
	};

	const handleCloseAttendanceModal = () => {
		setSelectedProgram('');
		setOpenAttendanceModal(false);
	};

	const handleCloseAssignmentModal = () => {
		setSelectedProgram('');
		setOpenAssignmentModal(false);
	};

	const filteredLearnerAttendance = selectedProgram
		? learnerOverviewData?.attendance?.filter(
				item => item.courseid === selectedProgram
			)
		: learnerOverviewData?.attendance;

	// const uniqueLearners = Array.from(
	// 	new Map(
	// 		filteredLearnerAttendance?.map(item => [item.userid, item]) || []
	// 	).values()
	// );

	// const learnerData = uniqueLearners.map((item, index) => ({
	// 	id: index + 1,

	// 	fullName: item.fullname,

	// 	enrolledProgram: item.coursetitle,

	// 	credentials: 'N/A',

	// 	role: 'Learner',
	// }));

	const learnerMap = new Map<string, any>();

(filteredLearnerAttendance || []).forEach(item => {
	const existingLearner = learnerMap.get(item.userid);

	if (existingLearner) {
		// Add program if it is not already present
		if (
			item.coursetitle &&
			!existingLearner.programs.includes(item.coursetitle)
		) {
			existingLearner.programs.push(item.coursetitle);
		}
	} else {
		// First record for this learner
		learnerMap.set(item.userid, {
			...item,
			programs: item.coursetitle ? [item.coursetitle] : [],
		});
	}
});

const learnerData = Array.from(learnerMap.values()).map(
	(item, index) => ({
		id: index + 1,

		fullName: item.fullname,

		enrolledProgram: item.programs.join(', '),

		credentials: 'N/A',

		role: 'Learner',
	})
);

	/* TABLE COLUMNS */
	const learnerColumns: {
		header: string;
		key:
			| 'id'
			| 'fullName'
			| 'enrolledProgram'
			| 'credentials'
			| 'role'
			| 'actions'
			| 'progress';
		render?: (item: any) => React.ReactNode;
		optional?: boolean;
	}[] = [
		{
			header: 'Full Name',
			key: 'fullName',
		},
		{
	header: 'Enrolled Program',
	key: 'enrolledProgram',
	render: (item: any) => {
		const programText = item.enrolledProgram || '';

		const maxLength = 40;

		const displayText =
			programText.length > maxLength
				? `${programText.substring(0, maxLength)}...`
				: programText;

		return (
			<span title={programText}>
				{displayText}
			</span>
		);
	},
},
		{
			header: 'ICC Credentials',
			key: 'credentials',
		},
		{
			header: 'Role',
			key: 'role',

			render: (item: any) => (
				<button
					style={{
						border: '1px solid #5b1871',
						background: '#FFFFFF',
						color: '#5b1871',
						borderRadius: '6px',
						padding: '6px 18px',
						fontSize: '1rem',
						fontWeight: 600,
						width: '150px',
						height: '40px',
					}}
				>
					{item.role}
				</button>
			),
		},
	];

	const filteredAssignments = selectedProgram
		? learnerOverviewData?.assignments?.filter(
				item => item.courseid === selectedProgram
			)
		: learnerOverviewData?.assignments;

	const filteredAttendance = selectedProgram
		? learnerOverviewData?.attendance?.filter(
				item => item.courseid === selectedProgram
			)
		: learnerOverviewData?.attendance;

	const uniqueAttendanceLearners = Array.from(
		new Map(
			filteredAttendance?.map(item => [item.userid, item]) || []
		).values()
	);

	const attendanceData = uniqueAttendanceLearners.map((item, index) => ({
		id: index + 1,

		fullName: item.fullname,

		completionRate: `${item.attendancerate || 0}%`,

		attendance: `${item.attendancerate || 0}%`,

		role: 'Learner',
	}));
	const attendanceColumns: {
		header: string;
		key:
			| 'id'
			| 'fullName'
			| 'completionRate'
			| 'attendance'
			| 'role'
			| 'actions'
			| 'progress';

		render?: (item: any) => React.ReactNode;
		optional?: boolean;
	}[] = [
		{
			header: 'Full Name',
			key: 'fullName',
		},

		{
			header: 'Completion Rate',
			key: 'completionRate',

			render: (item: any) => (
				<div
					style={{
						width: '85%',
						height: '8px',
						background: '#DCEFE8',
						borderRadius: '20px',
						overflow: 'hidden',
					}}
				>
					<div
						style={{
							width: item.completionRate,
							height: '100%',
							background: '#0E8A61',
							borderRadius: '20px',
						}}
					/>
				</div>
			),
		},

		{
			header: 'Attendance',
			key: 'attendance',
		},

		{
			header: 'Role',
			key: 'role',

			render: (item: any) => (
				<button
					style={{
						border: '1px solid #5b1871',
						background: '#FFF',
						color: '#5b1871',
						borderRadius: '6px',
						padding: '6px 18px',
						width: '120px',
						height: '38px',
						fontWeight: 600,
					}}
				>
					{item.role}
				</button>
			),
		},
	];

	const assignmentData =
		filteredAssignments?.map((item, index) => ({
			id: index + 1,

			fullName: item.fullname,

			// completionRate: item.completionrate,
			completionRate:
			item.totalassignments > 0
				? Math.round(
						(item.submitted / item.totalassignments) * 100
				  )
				: 0,

			assignments: `${item.submitted}/${item.totalassignments}`,

			role: 'Learner',
		})) || [];

	const assignmentColumns: {
		header: string;
		key: 'id' | 'fullName' | 'completionRate' | 'assignments' | 'role';

		render?: (item: any) => React.ReactNode;
	}[] = [
		{
			header: 'Full Name',
			key: 'fullName',
		},

		{
			header: 'Completion Rate',
			key: 'completionRate',

			render: (item: any) => (
				<div
					style={{
						width: '85%',
						height: '8px',
						background: '#DCEFE8',
						borderRadius: '20px',
						overflow: 'hidden',
					}}
				>
					<div
						style={{
							// width: item.completionRate,
							 width: `${item.completionRate}%`,
							height: '100%',
							background: '#0E8A61',
							borderRadius: '20px',
						}}
					/>
				</div>
			),
		},

		{
			header: 'Assignments',
			key: 'assignments',
		},

		{
			header: 'Role',
			key: 'role',

			render: (item: any) => (
				<button
					style={{
						border: '1px solid #5b1871',
						background: '#FFF',
						color: '#5b1871',
						borderRadius: '6px',
						padding: '6px 18px',
						width: '120px',
						height: '38px',
						fontWeight: 600,
					}}
				>
					{item.role}
				</button>
			),
		},
	];

	const programOptions =
		programs?.map((program: any) => ({
			label: program.title,
			value: program.id,
		})) || [];

	const selectedProgramLabel =
		programs?.find((program: any) => program.id === selectedProgram)
			?.title || '';

			
     const assignments = (learnerOverviewData?.assignments ?? []).filter(
	    (item) => item != null
     );

    const totalCompletionRate = assignments.reduce<number>(
	    (acc, curr) => {
		const total = Number(curr.totalassignments ?? 0);
		const submitted = Number(curr.submitted ?? 0);

		return acc + (total > 0 ? (submitted / total) * 100 : 0);
	    },
	     0
    );

    const assignmentCompletion =
	    assignments.length > 0
		? `${Math.round(totalCompletionRate / assignments.length)}%`
		: '0%';

	return (
		<div className={styles.container}>
			{/* CARD 1 */}
			<DashboardStatCard
				title="Learners Assigned"
				value={
					learnerOverviewLoading
						? '...'
						: String(
								learnerOverviewData?.summary?.totallearners || 0
							)
				}
				icon={learnerIcon}
				cardWidth="100%"
				cardHeight="140px"
				iconBackground="#DCE9FF"
				titleFontSize=" 1.125rem"
				valueFontSize="2.25rem"
				padding="16px"
				onClick={() => {
					setSelectedProgram('');
					setOpenLearnerModal(true);
				}}
			/>

			{/* CARD 2 */}
			<DashboardStatCard
				title="Average Attendance"
				// value="85%"
				value={
					learnerOverviewLoading
						? '...'
						: `${Math.round(
								(learnerOverviewData?.attendance?.reduce(
									(acc, curr) =>
										acc + Number(curr.attendancerate || 0),
									0
								) || 0) /
									(learnerOverviewData?.attendance?.length ||
										1)
							)}%`
				}
				icon={attendanceIcon}
				cardWidth="100%"
				cardHeight="140px"
				iconBackground="#F3DDF5"
				titleFontSize=" 1.125rem"
				valueFontSize="2.25rem"
				padding="16px"
				// onClick={() => setOpenAttendanceModal(true)}
				onClick={() => {
					setSelectedProgram('');
					setOpenAttendanceModal(true);
				}}
			/>

			{/* CARD 3 */}
			<DashboardStatCard
				title="Upcoming Sessions"
				// value="12"
				value={
					learnerOverviewLoading
						? '...'
						: String(
								learnerOverviewData?.summary
									?.upcomingsessions || 0
							)
				}
				icon={sessionIcon}
				cardWidth="100%"
				cardHeight="140px"
				iconBackground="#DFF2E1"
				titleFontSize=" 1.125rem"
				valueFontSize="2.25rem"
				padding="16px"
			/>

			{/* CARD 4 */}
			<DashboardStatCard
				title="Assignment Completion"							
                value={
	              learnerOverviewLoading ? '...' : assignmentCompletion
                }
				icon={assignmentIcon}
				cardWidth="100%"
				cardHeight="140px"
				iconBackground="#FFE8D2"
				titleFontSize=" 1.125rem"
				valueFontSize="2.25rem"
				padding="16px"
				// onClick={() => setOpenAssignmentModal(true)}
				onClick={() => {
					setSelectedProgram('');
					setOpenAssignmentModal(true);
				}}
			/>

			{/* MODAL */}
			<LearnersAssignedModal
				isOpen={openLearnerModal}
				// onClose={() => setOpenLearnerModal(false)}
				onClose={handleCloseLearnerModal}
				title="Learners Assigned"
				dropdownLabel="Program"
				dropdownPlaceholder="Select Program"
				dropdownOptions={programOptions}
				// selectedDropdown={selectedProgram}
				selectedDropdown={selectedProgramLabel}
				onDropdownSelect={setSelectedProgram}
				columns={learnerColumns}
				data={learnerData}
				itemsPerPage={5}
			/>
			<LearnersAssignedModal
				isOpen={openAttendanceModal}
				// onClose={handleCloseAttendanceModal}
				onClose={handleCloseAttendanceModal}
				title="Average Attendance"
				dropdownLabel="Program"
				dropdownPlaceholder="Select Program"
				dropdownOptions={programOptions}
				// selectedDropdown={selectedProgram}
				selectedDropdown={selectedProgramLabel}
				onDropdownSelect={setSelectedProgram}
				columns={attendanceColumns}
				data={attendanceData}
				itemsPerPage={5}
			/>

			<LearnersAssignedModal
				isOpen={openAssignmentModal}
				// onClose={() => setOpenAssignmentModal(false)}
				onClose={handleCloseAssignmentModal}
				title="Assignment Completion"
				dropdownLabel="Program"
				dropdownPlaceholder="Select Program"
				dropdownOptions={programOptions}
				// selectedDropdown={selectedProgram}
				selectedDropdown={selectedProgramLabel}
				onDropdownSelect={setSelectedProgram}
				columns={assignmentColumns}
				data={assignmentData}
				itemsPerPage={5}
			/>
		</div>
	);
};

export default DashboardStatsContainer;
